exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload_files{\r\n    border-radius:50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #f0f0f0;\r\n    cursor:pointer;\r\n    text-align:center;\r\n    width:150px;\r\n    height:150px;\r\n    margin: auto;\r\n}\r\n\r\n.upload_files:hover{\r\n    background-color:#022699\r\n}\r\n\r\n.upload_files:hover .upload,.upload_files:hover .upload_file_text {\r\n    color: #f0f0f0\r\n}\r\n\r\n.upload{\r\n    color:#022699;\r\n    margin-top: -25px\r\n}\r\n\r\n.upload_file_text{\r\n    margin:0;\r\n    font-size:16px;\r\n    font-weight:bold;\r\n    color:#022699;\r\n    display: block;\r\n}\r\n\r\n.file_upload_forms {\r\n    display: none;\r\n}\r\n\r\n.files {\r\n    margin-left: 30px;\r\n    font-size: 16px;\r\n\r\n}\r\n\r\n.files > ul {\r\n    list-style-type: none;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/bestanden.css
// module id = 49
// module chunks = 0